<app-package-groups #packageGroups (validityChange)="onValidityChange($event)" (valueChange)="onValueChange($event)"></app-package-groups>

<div class="d-flex justify-content-end mt-4">
  <button mat-button class="secondary-button" (click)="onAddPackageClick()">
    <svg-icon key="add" class="mr-1"></svg-icon>
    {{ 'TASKS.ADD_ANOTHER_PACKAGE' | translate }}
  </button>
</div>
